import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { StorageHelper } from '@smg-real-estate/hg-search-libs';

import { StorageNamespace } from '../storage-namespaces';

const storageHelper = new StorageHelper(StorageNamespace.detailsPage);

export const getContactFormRecaptchaSiteKey = (): string =>
  import.meta.env.VUE_RECAPTCHA_CONTACT_SITE_KEY ?? '';

export function getContactedOnStorageKey(listingId: string): string {
  return `contacted-${listingId}`;
}

export function getContactedOnDateForListing(listingId: string): string | undefined {
  const key = getContactedOnStorageKey(listingId);
  const item = storageHelper.getLocalStorageExpirableItem(key);
  return item ? item.date : undefined;
}

export function setContactedOnDateForListing(listingId: string): void {
  const key = getContactedOnStorageKey(listingId);
  const value = {
    date: new Date().toLocaleDateString(HgSupportedLanguage.DE + '-CH', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }),
  };
  const ttl = 180 * 24 * 60 * 60; // time to live in local storage: 180 days
  storageHelper.setLocalStorageExpirableItem(key, value, ttl);
}
